module.exports = __webpack_public_path__ + "img/return.ea72ba85.png";